module.exports = __webpack_public_path__ + "static/media/nobu_hero.e25b3987.jpg";